/**
 * Header cart badge — count, empty/hidden state, bump animation, fly-to-cart.
 * Target: #cartCount (.badge-count) on #cartBtn in sections/header.liquid
 */
(function () {
  var previousCount = null;
  var FLY_TO_CART_DELAY = 640;
  var prefersReducedMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseCount(itemCount) {
    return Math.max(0, parseInt(itemCount, 10) || 0);
  }

  function getBadge() {
    return document.getElementById('cartCount');
  }

  function getCartButton() {
    return document.getElementById('cartBtn') || document.querySelector('.js-cart-toggle, button.cart');
  }

  function renderBadge(q, shouldBump) {
    var badge = getBadge();
    if (!badge) return;

    badge.textContent = String(q);
    badge.setAttribute('data-empty', q === 0 ? 'true' : 'false');

    badge.classList.remove('bump');
    if (shouldBump && q > 0 && !prefersReducedMotion) {
      void badge.offsetWidth;
      badge.classList.add('bump');
    }
  }

  /**
   * @param {number|string} itemCount
   * @param {{ bump?: boolean }} [options]
   */
  function updateHeaderCartBadge(itemCount, options) {
    var q = parseCount(itemCount);
    var forceBump = Boolean(options && options.bump);
    var countIncreased = previousCount !== null && q > previousCount;
    var shouldBump = forceBump || countIncreased;

    renderBadge(q, shouldBump);
    previousCount = q;
  }

  function updateCartIconDirectly(itemCount, options) {
    updateHeaderCartBadge(itemCount, options);
  }

  /**
   * Animate a product image flying into the header cart icon.
   * @param {HTMLElement} fromEl - Source image element in the gallery
   * @param {string} [imgSrc] - Optional image URL override
   * @returns {number} Delay in ms before opening the cart drawer (0 if skipped)
   */
  function flyToCart(fromEl, imgSrc) {
    if (prefersReducedMotion || !fromEl) return 0;

    var cartBtn = getCartButton();
    var src = imgSrc || fromEl.currentSrc || fromEl.src;
    if (!cartBtn || !src) return 0;

    var fromRect = fromEl.getBoundingClientRect();
    var cartRect = cartBtn.getBoundingClientRect();
    if (!fromRect.width || !fromRect.height) return 0;

    var flyer = document.createElement('img');
    flyer.src = src;
    flyer.alt = '';
    flyer.className = 'header-cart-fly';
    flyer.style.left = fromRect.left + fromRect.width / 2 - 28 + 'px';
    flyer.style.top = fromRect.top + fromRect.height / 2 - 28 + 'px';
    document.body.appendChild(flyer);

    requestAnimationFrame(function () {
      var dx = cartRect.left + cartRect.width / 2 - (fromRect.left + fromRect.width / 2);
      var dy = cartRect.top + cartRect.height / 2 - (fromRect.top + fromRect.height / 2);
      flyer.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.18)';
      flyer.style.opacity = '0.2';
      flyer.style.borderRadius = '50%';
    });

    setTimeout(function () {
      flyer.remove();
    }, 820);

    return FLY_TO_CART_DELAY;
  }

  function initPreviousCount() {
    var badge = getBadge();
    if (badge) {
      previousCount = parseCount(badge.textContent);
    }
  }

  window.updateHeaderCartBadge = updateHeaderCartBadge;
  window.updateCartIconDirectly = updateCartIconDirectly;
  window.flyToCart = flyToCart;

  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail;
    if (!cart || cart.item_count == null) return;
    updateHeaderCartBadge(cart.item_count);
  });

  initPreviousCount();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreviousCount);
  }
})();
